import { state } from './register.state.js';
import { getters } from './register.getters.js';
import { actions } from './register.actions.js';
import { mutations } from './register.mutations.js';

export default {
  state,
  getters,
  actions,
  mutations
};
